import styled from 'styled-components'
import { colors } from 'client/styles'

export const FilterRatingsBase = styled.div`
  padding-block: 15px;
  padding-inline: 20px;
`

export const Title = styled.h3`
  color: ${colors.grey1};
  font-weight: 700;
  margin-block-end: 1rem;
`

export const List = styled.ul`
  display: flex;
  flex-direction: column;

  > li {
    margin-block: 0 5px;
    margin-inline: 0;
    font-size: 16px;
    label {
      text-transform: capitalize;
    }
  }
`
